import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { fetchMeta } from "@/lib/api";

export const MegaMenu = ({ onClose }) => {
  const { data } = useQuery({ queryKey: ["meta"], queryFn: fetchMeta });
  const sizes = data?.sizes || [];
  const surfaces = data?.surfaces || [];
  const spaces = data?.spaces || [];

  return (
    <motion.div
      data-testid="mega-menu"
      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} transition={{ duration: 0.3 }}
      className="hidden lg:block absolute inset-x-0 top-full border-t border-slate-200/80 bg-white/[0.97] backdrop-blur-xl shadow-[0_30px_60px_-30px_rgba(19,34,56,.45)]"
    >
      <div className="container-x grid grid-cols-12 gap-10 py-10">
        <div className="col-span-3">
          <p className="eyebrow mb-5">By Size</p>
          <ul className="space-y-1">
            {sizes.map((s) => (
              <li key={s.slug}>
                <Link onClick={onClose} to={`/collection?size=${s.slug}`} data-testid={`mega-size-${s.slug}`} className="group flex items-center justify-between rounded-lg px-3 py-2 text-sm font-medium text-[var(--navy)] hover:bg-white transition-colors">
                  {s.label} <ArrowRight size={14} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-[var(--mint)]" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-span-5">
          <p className="eyebrow mb-5">By Surface</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-1">
            {surfaces.map((s) => (
              <li key={s.slug}>
                <Link onClick={onClose} to={`/collection?surface=${s.slug}`} data-testid={`mega-surface-${s.slug}`} className="flex items-center justify-between rounded-lg px-3 py-1.5 text-sm text-[var(--navy)] hover:bg-white transition-colors">
                  <span>{s.label}</span>
                  {s.is_new && <span className="font-mono text-[0.55rem] uppercase tracking-widest text-white bg-[var(--mint)] rounded-full px-2 py-0.5">New</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-span-4">
          <p className="eyebrow mb-5">By Space</p>
          <div className="grid grid-cols-3 gap-3">
            {spaces.map((sp) => (
              <Link onClick={onClose} key={sp.slug} to={`/collection?space=${sp.slug}`} data-testid={`mega-space-${sp.slug}`} className="group relative aspect-[4/5] overflow-hidden rounded-xl">
                <img src={sp.image} alt={sp.label} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b1526]/80 via-transparent to-transparent" />
                <span className="absolute bottom-2 left-2 right-2 text-xs font-semibold text-white">{sp.label}</span>
              </Link>
            ))}
          </div>
          <Link onClick={onClose} to="/collection" data-testid="mega-view-all" className="btn-pill btn-ghost mt-5 w-full justify-center text-xs">View full catalogue <ArrowRight size={14} className="arrow" /></Link>
        </div>
      </div>
    </motion.div>
  );
};
